/**
 * Google OAuth always returns to /auth/callback, so the page the employee
 * actually asked for has to survive the round trip. Slack links straight to a
 * Dev Agent run made this load-bearing: without it, anyone not already signed
 * in authenticates and lands on Home instead of the run they opened.
 */

const AUTH_RETURN_KEY = 'mentra-employee-auth-return';

export function rememberAuthReturn(): void {
  const target = `${window.location.pathname}${window.location.search}`;
  if (isRestorablePath(target)) window.sessionStorage.setItem(AUTH_RETURN_KEY, target);
}

/** Returns the path to restore, or null to stay where sign-in landed. */
export function restorePendingAuthorization(hasSession: boolean): string | null {
  if (!hasSession || !window.location.pathname.startsWith('/auth/callback')) return null;
  const pending = window.sessionStorage.getItem(AUTH_RETURN_KEY);
  window.sessionStorage.removeItem(AUTH_RETURN_KEY);
  if (!pending || !isRestorablePath(pending)) return null;
  window.history.replaceState({}, '', pending);
  return pending;
}

/** Same-origin app paths only: "//host" would redirect off-site, and returning
 * to the callback itself would loop. */
function isRestorablePath(target: string): boolean {
  return target.startsWith('/')
    && !target.startsWith('//')
    && !target.startsWith('/auth/callback');
}
